module.exports = "<p ng-repeat=\"gallery in $ctrl.data\">\n    <a style=\"float:right; margin-left: 8px\" ng-href=\"/gallery/{{gallery._id}}\" class=\"btn btn-sm btn-more\"><i class=\"fa fa-arrow-circle-right\"></i> more</a>\n    <b>{{gallery.title}}</b><br/><em ng-bind-html=\"$ctrl.getPreviewText(gallery.description)\"></em>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/galleries-widget/galleries-widget.component.html
// module id = 559
// module chunks = 0